<template>
  <section>
    <framed-image :navigate-to="productImage" :images="productImages" />
    <div class="mx-2">
      <h2>What size would you like?</h2>
      <div class="buttons flex-wrap">
        <standard-button 
          v-for="item in filteredProducts" :key="item.sku"
          @click="setSku(item.sku)"
          :active="value == item.sku"
        >
          {{item.size}} <em class="lowercase">for</em>
          {{item.amount | tightCurrency }}
          <template v-slot:hint>{{item.description}}</template>
        </standard-button>
      </div>
    </div>
  </section>
</template>


<script>
import FramedImage from './FramedImage'
import StandardButton from './StandardButton'
import { filter, map, findIndex, find } from 'lodash'
export default {
  model: {
    value: 'value',
    event: 'input'
  },
  props: {
    value: {},
    group: {},
  },
  components: {
    FramedImage,
    StandardButton
  },

  methods: {
    setSku(id) {
      this.$emit('input',id)
      this.$scrollTo(document.getElementById('flavours'), 1000, { offset: -50 })
    }
  },
  computed: {
    filteredProducts() {
      return filter(this.$root.$data.products, {group: this.group})
    },
    productImages() {
      if(this.group.includes('christmas')) {
        return ["https://res.cloudinary.com/drydj65ky/image/upload/v1606338798/J-Bird_Christmas-35_kaljxu.jpg"]
      } else {
        return [this.groupImage].concat(map(this.filteredProducts, 'image'))
      }
    },
    groupImage() {
      return find(this.$root.$data.groups, {id: this.group}).image
    },
    productImage() {
      return findIndex(this.filteredProducts, {sku: this.value}) + 1
    },
  }
}
</script>
